<template>
    <div>
        <b-card class="card">
            <b-nav class="menu" vertical>
                <b-nav-item active>
                    <router-link :to="{ name: 'home' }">
                        <b-icon-newspaper class="menu-icon"/>
                        Новости
                    </router-link>
                </b-nav-item>
                <b-nav-item>
                    <router-link :to="{ name: 'notifications' }">
                        <b-icon-bell class="menu-icon"/>
                        Уведомления
                    </router-link>
                </b-nav-item>
                <b-nav-item>
                    <router-link :to="{ name: 'settings' }">
                        <b-icon-gear-fill class="menu-icon"/>
                        Настройки
                    </router-link>
                </b-nav-item>
            </b-nav>
            <b-button block class="menu__button" variant="outline-primary" @click="logOut">Выйти</b-button>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "Menu",
        data: () => ({}),
        methods: {
            logOut() {
                localStorage.clear();
                this.$router.push({ name: 'login' });
            },
        }
    }
</script>

<style scoped>
    .menu {
        margin-bottom: 50px;
    }

    li {
        list-style-type: none;
        color: black;
    }
</style>